import { baseService } from "../base";
import { 
  PayrollSetting, 
  CreatePayrollSettingDto, 
  UpdatePayrollSettingDto, 
  UpsertPayrollSettingDto 
} from "~/types/payroll";

export const payrollSettingsService = {
  // Get all payroll settings
  getAll: async (): Promise<PayrollSetting[]> => {
    const { data } = await baseService.get<PayrollSetting[]>("/payroll-settings");
    return data;
  },

  // Get setting by ID
  getById: async (id: string): Promise<PayrollSetting> => {
    const { data } = await baseService.get<PayrollSetting>(`/payroll-settings/${id}`);
    return data;
  },

  // Get setting by key
  getByKey: async (key: string): Promise<PayrollSetting> => {
    const { data } = await baseService.get<PayrollSetting>(`/payroll-settings/key/${key}`);
    return data;
  },

  // Create new setting
  create: async (dto: CreatePayrollSettingDto): Promise<PayrollSetting> => {
    const { data } = await baseService.post<PayrollSetting>("/payroll-settings", dto);
    return data;
  },

  // Update existing setting
  update: async (id: string, dto: UpdatePayrollSettingDto): Promise<PayrollSetting> => {
    const { data } = await baseService.put<PayrollSetting>(`/payroll-settings/${id}`, dto);
    return data;
  },

  // Upsert setting by key
  upsertByKey: async (key: string, dto: UpsertPayrollSettingDto): Promise<PayrollSetting> => {
    const { data } = await baseService.post<PayrollSetting>(
      `/payroll-settings/upsert/${key}`, 
      dto
    );
    return data;
  },

  // Delete setting
  delete: async (id: string): Promise<void> => {
    await baseService.delete(`/payroll-settings/${id}`);
  },

  // Helper: Get all settings as a key-value map
  getSettingsMap: async (): Promise<Record<string, string>> => {
    const settings = await payrollSettingsService.getAll();
    return settings.reduce((acc, setting) => {
      acc[setting.key] = setting.value;
      return acc;
    }, {} as Record<string, string>);
  },

  async getPayrollInvoiceDetail(id: string) {
    const response = await baseService.get(`/payroll/${id}/detail`);
    return response.data;
  },

  async createWithQuickBooks(data: CreatePayrollInvoiceDto) {
    // Implementation of createWithQuickBooks method
  },
};
